var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 9.99999H13.3333V11.6667H6.66659V9.99999ZM8.33325 16.6667H4.99992V3.33332H10.8333V7.49999H14.9999V10.0833L16.6666 8.41666V6.66666L11.6666 1.66666H4.99992C4.55789 1.66666 4.13397 1.84225 3.82141 2.15481C3.50885 2.46737 3.33325 2.8913 3.33325 3.33332V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H8.33325V16.6667ZM6.66659 15H10.0833L10.8333 14.25V13.3333H6.66659V15ZM16.8333 10.8333C16.9166 10.8333 17.0833 10.9167 17.1666 11L18.2499 12.0833C18.4166 12.25 18.4166 12.5833 18.2499 12.75L17.4166 13.5833L15.6666 11.8333L16.4999 11C16.5833 10.9167 16.6666 10.8333 16.8333 10.8333ZM16.8333 14.0833L11.7499 19.1667H9.99992V17.4167L15.0833 12.3333L16.8333 14.0833Z",
    fill: "#7100DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralNotes);
export default __webpack_public_path__ + "static/media/referral_notes.4d6144c2a82a730ba183a567ef29e232.svg";
export { ForwardRef as ReactComponent };